const messages = {
    en:{
        translations:{
            titulos:{
                titulo: 'Pineapple',
                tituloSobre: 'About Pineapple',
                Efruta: 'Is it really fruit?'
            },

            textos:{
                abacaxi:'Pineapples are yellowish tropical fruits.',
                abacaxiSobre: 'Pineapple is a good ally. After all, it has vitamins, minerals and enzymes, such as bromelain. These nutrients help strengthen the immune system and eliminate inflammation in the body. Helps in weight loss: being a diuretic food, pineapple helps in the elimination of fluids and toxins from the body.',
                abacaxiE: 'Pineapple, strawberry and fig are fruits, right? Wrong! They are infructescence: the result of the fusion of several flowers that, after being fertilized, come together in a single fruit or infructescence.'
            },

            seletores:{
                escolhaIdioma: 'Choose a language',
                idioma1: 'Brazilian Portuguese',
                idioma2: 'English',
                idioma3: 'Spanish',
            },

            botoes:{
                comprarAbacaxi: 'Purchase?'
            }
        }
    }
}
export {messages}